import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';
import ReusableInfo from '../../../../../../reusables/Info';

interface IProps {
  handlerOnNext: () => void;
  handlerClose: () => void;
  show: boolean;
  periodsSelected: number;
}

const ActivatePayment = ({
  handlerOnNext,
  handlerClose,
  show,
  periodsSelected
}: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Sí, actívalo"
    handlerButtonA={() => handlerOnNext()}
    textButtonB="Cancelar"
    handlerButtonB={() => handlerClose()}
  >
    <DialogExtraCaption
      subtitle={
        periodsSelected === 1
          ? `Has seleccionado ${periodsSelected} ciclo, al aceptar se cargará el monto de S/.${
              periodsSelected * 27
            }.00 a tus pagos pendientes.`
          : `Has seleccionado ${periodsSelected} ciclos, al aceptar se cargará el monto de S/.${
              periodsSelected * 27
            }.00 a tus pagos pendientes.`
      }
      title="¿Estás seguro de activar el pago?"
    />
    <ReusableInfo
      style={{ margin: '12px 32px 0px 32px' }}
      iconName="alert-circle"
      text="Recuerda que los items de pago se cargarán por separado."
    />
  </Dialog>
);

export default ActivatePayment;
